import { apiService } from 'core/services/apiService';

export interface LocalEvent {
    '@id': string;
    '@type': string;
    id: number;
    title: string;
    date: string;
    time: string;
    timezone: string;
    sport: string | null;
    teams: string | null;
    why_hot: string;
    broadcast: string | null;
    city: string;
    country: string;
    zipcode: string;
}

export const getLocalEvents = async (workplaceId: number): Promise<LocalEvent[]> => {
    try {
        const response = await apiService.get('/common/game_master_ai_community_events', {
            params: { workplace: workplaceId }
        });
        const data = response?.data;
        // console.log('Fetched Local Events Data:', data);
        // The API returns an array or hydra collection
        return Array.isArray(data) ? data : data?.['hydra:member'] || data?.member || [];
    } catch (error) {
        console.error('Error fetching local events:', error);
        return [];
    }
};